import Notice from './notice';
import Contents from './contents';
import Patch from './patchnote';

function Postbox() {
    return(

        <div>
        <div className='post-box'>
            <Notice />
            <Contents />
            <Patch />
        </div>
        </div>
    )
};

export default Postbox;